"use client";

import React, { memo, useMemo } from "react";
import dynamic from "next/dynamic";
import { moviesList } from "@/config/statics";
import { Card } from "@nextui-org/react";
import Link from "next/link";
import { ROUTES } from "@/routes/appRoutes";

import lottieJson from "../../../public/moftabakh-animation.json";

const Lottie = dynamic(() => import("react-lottie-player"), {
  ssr: false,
  loading: () => <div className="h-[110px] sm:h-[180px] md:h-[200px] lg:h-[200px] aspect-[18/10] bg-gray-800 animate-pulse rounded" />,
});

// Memoized movie card component
const MovieCard = memo(({ item, index, className }) => (
  <Card
    key={`movie-${index}-${item.name}`}
    radius="lg"
    className={className}
  >
    <img
      alt={item.name}
      className="object-cover w-full h-full"
      width={220}
      height={300}
      loading="lazy"
      src={item.image}
    />
  </Card>
));

MovieCard.displayName = 'MovieCard';

const ImageAnimations = memo(() => {
  // Memoize the repeated cards to avoid triple rendering
  const movieCards = useMemo(() => {
    const cardClassName = "!w-[110px] sm:!w-[140px] md:!w-[160px] lg:!w-[220px] border-none h-[160px] sm:h-[200px] md:h-[240px] lg:h-[300px] mx-4";

    return moviesList?.map((item, index) => (
      <MovieCard
        key={`card-${index}`}
        item={item}
        index={index}
        className={cardClassName}
      />
    ));
  }, []);

  return (
    <>
      <div className="rotate-23 translate-x-1/4 flex-col opacity-70">
        <div className="flex animate-firstRowRunner mb-6">
          {movieCards}
        </div>
        <div className="flex animate-secondRowRunner mb-6">
          {movieCards}
        </div>
        <div className="flex animate-thirdRowRunner">
          {movieCards}
        </div>
      </div>
      <Link href={ROUTES.free} className="absolute w-screen top-0 left-0 right-0 bottom-0 z-10">
        <div className="flex items-center w-full h-full justify-end lg:pl-24">
          <Lottie
            loop
            animationData={lottieJson}
            play={true}
            className="h-[110px] sm:h-[180px] aspect-[18/10] md:h-[200px] lg:h-[200px]"
          />
        </div>
      </Link>
    </>
  );
});

ImageAnimations.displayName = 'ImageAnimations';

export default ImageAnimations;
